import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ActiveHand} from './active-hand.js';
import {Cursor} from '@wonderlandengine/components';

export class ActivateCursorOnHand extends Component {
    static TypeName = 'activate-cursor-on-hand';

    @property.object()
    activeHandObject?: Object3D;

    @property.enum(['Left', 'Right'], 'Right')
    activateOnHand = 1;

    private activeHand?: ActiveHand;
    private cursorComponent?: Cursor;

    start() {
        if (!this.activeHandObject) {
            throw new Error(
                `activate-on-hand(${this.object.name}):activeHandObject is not defined`
            );
        }
        const tempActiveHand = this.activeHandObject.getComponent(ActiveHand);
        if (!tempActiveHand) {
            throw new Error(
                `activate-on-hand(${this.object.name}):activeHandObject does not have a ActiveHand component`
            );
        }
        this.activeHand = tempActiveHand;

        const tempCursorComponent = this.object.getComponent(Cursor);
        if (!tempCursorComponent) {
            throw new Error(
                `activate-on-hand(${this.object.name}):This object does not have a Cursor component`
            );
        }
        this.cursorComponent = tempCursorComponent;
        this.cursorComponent.active =
            this.activeHand.activeHand == ['left', 'right'][this.activateOnHand];
    }

    onActivate(): void {
        this.activeHand!.onActiveHandChanged.add(this.onActiveHandChanged);
    }

    onDeactivate(): void {
        this.activeHand!.onActiveHandChanged.remove(this.onActiveHandChanged);
    }

    onActiveHandChanged = (hand: 'left' | 'right') => {
        this.cursorComponent!.active = hand == ['left', 'right'][this.activateOnHand];
    }
}
